import React from "react";
import styled from "styled-components";

import chrome from "../imgs/chrome.svg";

const MenuContainer = styled.div`
  display: none;
  background: white;
  width: 500px;
  height: 100vh;
  color: ${({ theme }) => theme.colors.primary};
  @media only screen and (min-width: 768px) {
    display: flex;
    flex-direction: column;
  }
  h1 {
    margin-top: 0;
    font-size: 32px;
  }
  h2 {
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
  }
  padding: 20px;
`;

const Install = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  img {
    width: 60px;
  }
  a {
    width: 100%;
    text-align: center;
    margin-left: 20px;
    text-decoration: none;
    background-image: linear-gradient(
      45deg,
      rgb(82, 155, 224) 0%,
      rgb(93, 71, 240) 100%
    );
    padding: 20px;
    border-radius: 3px;
    color: white;
  }
`;

const DesktopMenu = () => {
  return (
    <MenuContainer>
      <h1>
        Alreet, welcome to Geordify!
      </h1>
      <h2>
        Geordify translates 104 languages into Geordie and vice versa.
        It currently has just over 340 translations.
      </h2>
      <h2>
        Geordify is available as an extension for Google Chrome. It translates webpages and the live feeds of Twitter and Facebook.
      </h2>
      <Install>
        <img src={chrome} alt="Get the chrome Extension" />
        <a
          href="https://chrome.google.com/webstore/detail/geordify/adghhgkpcaioipapmgfopnekjpnabecb?utm_source=chrome-ntp-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          Geordify the web!
        </a>
      </Install>
    </MenuContainer>
  );
};

export default DesktopMenu;



// WEBPACK FOOTER //
// ./src/components/DesktopMenu.js